<!-- eslint-disable vue/no-v-html -->
<template>
  <client-only>
    <div
      v-if="dataIsConsentGiven === null || dataIsConsentGiven === undefined"
      class="fixed inset-0 bg-gray-800/50 z-[999]"
      >
      <div class="fixed left-0 right-0 bottom-0 z-[900] !bg-white/80 backdrop-blur m-4 !p-0 ui-card !shadow-xl">
        <div class="flex flex-wrap p-4 gap-y-4">
          <p class="self-center">
            {{ t('consent.textBefore') }}
            <strong v-text="t('consent.cookies')" />
            {{ t('consent.textBetween') }}
            <strong v-text="t('consent.localStorage')" />
            {{ t('consent.textAfter') }}
            <ui-link
              to="/privacy#cookies"
              class="text-blue-600 font-medium"
              :text="t('Privacy Policy')"
              />
          </p>
          <div class="w-min flex justify-end gap-6 flex-grow m-0 items-center">
            <span
              class="text-gray-600"
              @click="useConsent(false)"
              v-text="t('Decline')"
              />
            <ui-button
              class="dark"
              :text="t('Consent')"
              @click="useConsent(true)"
              />
          </div>
        </div>
      </div>
    </div>
    <div
      v-if="dataIsConsentGiven !== null && !isAuthed && (Capacitor.getPlatform() !== 'web')"
      class="fixed left-4 bottom-0 z-[60]"
      @click="dataIsConsentGiven = null"
      >
      <i class="fas fa-cookie-bite text-2xl text-blue-600 bg-white p-2 shadow shadow-gray-400 rounded-t-full"/>
    </div>
  </client-only>
</template>

<script setup lang="ts">
import { Capacitor } from '@capacitor/core'

const dataIsConsentGiven = useState<boolean|null>('isConsentGiven', () => null)

const { t } = useI18n({
  messages: {
    en: {
      privacyPolicy: 'Privacy Policy',
      consent: {
        textBefore: 'We use',
        cookies: 'cookies',
        textBetween: 'and',
        localStorage: 'localStorage',
        textAfter: 'to ensure app functionality. Read more in our'
      }
    },
    de: {
      privacyPolicy: 'Datenschutzerklärung',
      consent: {
        textBefore: 'Wir verwenden',
        cookies: 'Cookies',
        textBetween: 'und',
        localStorage: 'localStorage',
        textAfter: 'um die Funktionalität der App zu gewährleisten. Mehr dazu in unserer'
      }
    },
    es: {
      privacyPolicy: 'Política de privacidad',
      consent: {
        textBefore: 'Usamos',
        cookies: 'cookies',
        textBetween: 'y',
        localStorage: 'localStorage',
        textAfter: 'para garantizar la funcionalidad de la aplicación. Lea más en nuestra'
      }
    },
    uk: {
      privacyPolicy: 'Політика конфіденційності',
      consent: {
        textBefore: 'Ми використовуємо',
        cookies: 'cookies',
        textBetween: 'та',
        localStorage: 'localStorage',
        textAfter: 'для забезпечення функціональності додатка. Дізнайтеся більше у нашій'
      }
    }
  }
} as any)

onMounted(() => {
  if(Capacitor.getPlatform() !== 'web'){
    console.log('Platform is '+Capacitor.getPlatform())
    useConsent(true)
  }

  if(localStorage.getItem('consent')){
    dataIsConsentGiven.value = (localStorage.getItem('consent') === 'true') ? true : null
  }
})

const useConsent = (consent: boolean) => {
  dataIsConsentGiven.value = consent
  localStorage.setItem('consent', (!!consent).toString())
}
</script>
